import * as React from 'react';
import type {ReactNode} from 'react';
import {createViewConfig, view} from '@sail/engine';
import type {View} from '@sail/engine';
import {cancel} from '@sail/icons/react/Icon';
import {useIntl} from '@sail/intl';
import {Action} from '../Action';
import {Icon} from '../Icon';
import {actionButton} from '../../utilStyles/ActionButton';
import {css} from '../../css';
import {closeButtonLabel} from './messages';

export type PopoverBottomSheetHeaderProps = View.IntrinsicElement<
  'div',
  {
    /** Title for the header */
    title?: ReactNode;
    titleId?: string;
    onClose?: () => void;
  }
>;

export const PopoverBottomSheetHeaderConfig = createViewConfig({
  props: {} as PopoverBottomSheetHeaderProps,
  name: 'PopoverBottomSheetHeader',
});

export const PopoverBottomSheetHeader =
  PopoverBottomSheetHeaderConfig.createView(
    ({title, onClose, titleId, ...props}) => {
      const intl = useIntl();

      return (
        <view.div
          css={[
            css({
              stack: 'x',
              flexGrow: 0,
              paddingX: 'space.250',
            }),
            title
              ? css({
                  distribute: 'space-between',
                  alignX: 'start',
                  paddingTop: 'medium',
                  paddingBottom: 'space.150',
                })
              : css({
                  distribute: 'packed',
                  alignX: 'end',
                  paddingTop: 'space.150',
                }),
          ]}
          {...props}
        >
          {title ? (
            <view.h2
              id={titleId}
              css={{
                margin: 'space.0',
                color: 'text',
                font: 'heading.small',
              }}
            >
              {title}
            </view.h2>
          ) : null}
          <Action
            aria-label={intl.formatMessage(closeButtonLabel)}
            onPress={onClose}
            uses={actionButton}
            css={{bleedRight: 'small'}}
          >
            <Icon icon={cancel} />
          </Action>
        </view.div>
      );
    },
  );
